import { useRef } from "react";
import { TIPO_CONTRATO } from "../utils/HospitalizacionConstants";
import {
  Container,
  ButtonOutline,
  Field,
  Label,
  Input,
  Select,
  ButtonsRow,
  ButtonPrimary,
} from "../styles/CalculadoraOxigenoStyles";

export default function CalculadoraOxigeno({
  prestador,
  tarifa,
  contratoTipo,
  cantidadLitros,
  montoReclamado,
  onChangeContratoTipo,
  onChangeCantidadLitros,
  onChangeMontoReclamado,
  onCalcular,
  onLimpiar,
  onCancelar,
  onAplicar,
}) {
  const isLitro = contratoTipo === TIPO_CONTRATO.LITRO;

  const skipNextBlurRef = useRef(false);

  const shouldTrigger = (value, readOnly) => {
    if (readOnly) return false;
    const v = String(value ?? "").trim();
    return v.length > 0;
  };

  const triggerCalculo = (source) => {
    if (!onCalcular) return;

    onCalcular({
      source,
      contratoTipo,
      tarifa,
      cantidadLitros,
      montoReclamado,
    });
  };

  const handleBlurLitros = () => {
    if (skipNextBlurRef.current) {
      skipNextBlurRef.current = false;
      return;
    }
    const readOnly = !isLitro;
    if (!shouldTrigger(cantidadLitros, readOnly)) return;
    triggerCalculo(TIPO_CONTRATO.LITRO);
  };

  const handleBlurMonto = () => {
    if (skipNextBlurRef.current) {
      skipNextBlurRef.current = false;
      return;
    }
    const readOnly = isLitro;
    if (!shouldTrigger(montoReclamado, readOnly)) return;
    triggerCalculo(TIPO_CONTRATO.MONTO);
  };

  const handleEnter = (e, kind) => {
    if (e.key !== "Enter") return;
    e.preventDefault();

    skipNextBlurRef.current = true;

    if (kind === TIPO_CONTRATO.LITRO) handleBlurLitros();
    if (kind === TIPO_CONTRATO.MONTO) handleBlurMonto();

    e.currentTarget.blur();
  };

  /** Solo dígitos y un punto decimal; sin signos +, -, ni 'e'. */
  const sanitizeMonto = (raw) => {
    const cleaned = String(raw ?? "").replace(/[^\d.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length <= 1) return parts[0] || "";
    return parts[0] + "." + parts.slice(1).join("").replace(/\D/g, "");
  };

  const handleMontoChange = (e) => {
    const sanitized = sanitizeMonto(e.target.value);
    onChangeMontoReclamado(sanitized);
  };

  return (
    <Container>
      <Field>
        <Label>Prestador</Label>
        <Input value={prestador} readOnly $readOnly />
      </Field>

      <Field>
        <Label>Tarifa contratada</Label>
        <Input value={tarifa} readOnly $readOnly />
      </Field>

      <Field>
        <Label>Contrato oxígeno</Label>
        <Select
          value={contratoTipo}
          onChange={(e) => onChangeContratoTipo(e.target.value)}
        >
          <option value={TIPO_CONTRATO.LITRO}>Litro</option>
          <option value={TIPO_CONTRATO.MONTO}>Monto</option>
        </Select>
      </Field>

      <Field>
        <Label>Cantidad total de litros</Label>
        <Input
          type="text"
          inputMode="decimal"
          value={cantidadLitros}
          readOnly={!isLitro}
          $readOnly={!isLitro}
          onChange={onChangeCantidadLitros}
          onBlur={handleBlurLitros}
          onKeyDown={(e) => handleEnter(e, TIPO_CONTRATO.LITRO)}
        />
      </Field>

      <Field>
        <Label>Monto reclamado</Label>
        <Input
          type="text"
          inputMode="decimal"
          value={montoReclamado}
          readOnly={isLitro}
          $readOnly={isLitro}
          onChange={handleMontoChange}
          onBlur={handleBlurMonto}
          onKeyDown={(e) => handleEnter(e, TIPO_CONTRATO.MONTO)}
        />
      </Field>

      <ButtonsRow>
        <ButtonOutline type="button" onClick={onLimpiar}>
          Limpiar calculo
        </ButtonOutline>
        <ButtonOutline type="button" onClick={onCancelar}>
          Cancelar
        </ButtonOutline>
        <ButtonPrimary type="button" onClick={onAplicar}>
          Aplicar
        </ButtonPrimary>
      </ButtonsRow>
    </Container>
  );
}
